<template>
    <div class="block" >
        <img class="bg" src="../../assets/image/choujiang.png" alt="">
        <div class="canrun">剩余抽奖次数：{{canRunCount}}次</div>
        <div class="jiqi">
            <div class="box pa" id='box'></div>
            <img class="img" src="../../assets/image/jiqi.png" alt="">
            <img v-if="showGift" class="gift pa" :src="chouzhong.img" alt="">
            <div class="voice to">
                <img src="../../assets/image/voice.png" class="icon" alt="">
                <el-carousel height="20px" direction="vertical" class="run to" :autoplay="true">
                    <el-carousel-item v-for="(item, index) in tongzhi" :key="index">
                        <div class="medium to">恭喜用户{{ item.nickName}}获得{{ item.giftName}}</div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div :class='"button button-choujiang" + (disabled?" disabled":"")' @click="start">抽奖</div>
            <div class='button button-home' @click="$router.push('/')">返回首页</div>
        </div>
        

        <!-- 分数奖励 -->
        <el-dialog
            :visible.sync="dialogjifen"
            width="80%"
            title="恭喜您抽中"
            center
            :close-on-click-modal="false"
        >
            <div class="chouzhong-name chouzhong-name-red">{{chouzhong.name}}</div>
            <br/>
            <div class="button" @click="dialogjifen = false">立即领取</div>

        </el-dialog>
        <!-- 谢谢参与 -->
        <el-dialog
            :visible.sync="dialogNo"
            width="80%"
            title="未中奖"
            center
            :close-on-click-modal="false"
        >
            <div class="chouzhong-name">谢谢参与</div>
            <br/>
            <div class="button" @click="dialogNo = false">继续抽奖</div>

        </el-dialog>
        <!-- 花费弹窗手机号奖励 -->
        <el-dialog
            :visible.sync="dialogPhone"
            width="80%"
            title="恭喜您抽中"
            center
            :close-on-click-modal="false"
        >
            <div v-if="chouzhong.name" class="chouzhong-name chouzhong-name-red">{{chouzhong.name}}</div>
            <br/>
            <div style="text-indent: 2em">奖品预计会在本次活动结束后的次月底前发放至您注册中银基金手机会员所使用的手机号中，敬请关注。</div>
            <br/>
            <!-- <div class="inp-box">
                <input type="text" v-model="phone" placeholder="手机号"/>
            </div> -->
            <div class="button" @click="dialogPhone = false">确 定</div>
        </el-dialog>
    </div>
</template>

<script>
    // import axios from 'axios'
import api from '@/assets/js/api'
import { cookie } from '@/assets/js/utils'
    export default {
        name: "notice",
        data() {
            return {
                actId: 1,
                canSubmitPhone: true,
                // phone: '',
                dialogjifen: false,
                dialogPhone: false,
                dialogNo: false, // 谢谢参与
                tongzhi: [],
                giftList: [], // 奖品列表
                prize: 8,
                showGift: false,
                disabled: {}, // 不可抽奖
                chouzhong: {},
                canRunCount: 0 // 剩余抽奖此事
               
            }
        },
        methods: {
            init(){
                let self = this;
                let giftList = self.giftList;
                let n1 = Math.floor(Math.random() * giftList.length + 1) -1;
                let n2 = Math.floor(Math.random() * giftList.length + 1) -1;
                let n3 = Math.floor(Math.random() * giftList.length + 1) -1;
                // console.log(n1,n2,n3)
                let top = 145;
                for (let index = 0; index < giftList.length; index++) {
                    let el = document.getElementById('ball' + index)
                    el.style.left = (200 - 60) * Math.random() + 'px';
                    if(n1 == index || n2 == index || n3 == index){
                        top = 100;
                    }
                    // console.log(top)
                    el.style.top = top - (20 *Math.random() +0) + 'px';
                }
                self.disabled = false;
            },
            
            getCanRunNums(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    // self.onShowLoginPop();
                    self.$message({
                        message: '需要先登陆哦！'
                    })
                    return;
                }
                api({
                    method: 'canRunCount',
                    token
                })
                .then(res => {
                    let { data, code } = res && res.data;
                    if(code == 200){
                        self.canRunCount = data.canRunCount;
                    }
                })
            },
            getZhongjiang(){
                let self = this;
                api({
                    method: 'lastWinNote',

                }).then(res => {
                    let {data, code ,msg} = res && res.data;
                    if(code == 200){
                        self.tongzhi = data;
                    }else{
                        // console.log(msg)
                    }
                    
                })
            },
            createEl(){
                let self = this;
              
                try {
                    let box = document.getElementById('box');
                    for (let index = 0; index < self.giftList.length; index++) {
                        let el = document.createElement('img');
                        el.id = 'ball' + index;
                        el.style.width = '60px';
                        el.style.height = '60px';
                        el.src = self.giftList[index].img;
                        el.className = 'ball pa';
                        box.appendChild(el);
                        
                    }
                } catch (error) {
                    // console.log(error)
                }
                self.init()
                
                
            },
            async start(){
                let self = this;
                if(self.disabled){
                    return;
                }

                if(Number(self.canRunCount) <= 0){
                    self.$message({
                        message: '抽奖次数已经用完了'
                    })
                    return;
                }
                self.showGift = false;
                self.disabled = true;

                let token = cookie.get('token'+self.actId);
                if(!token){
                    // self.onShowLoginPop();
                    self.$message({
                        message: '需要先登陆哦！'
                    })
                    return;
                }
                let res = await api({
                    method: 'run',
                    token
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                // code = 170;
                if(code ==200){
                    self.chouzhong = data;
                    self.canRunCount = self.chouzhong.canRunCount;
                    self.getZhongjiang(); // 小喇叭

                }else{
                    self.$message({
                        message: msg || '抽奖失败'
                    })
                    self.disabled = false;
                    return;
                }
                
                for (let index = 0; index < self.giftList.length; index++) {
                    let el = document.getElementById('ball' + index)
                    this.move(el);
                }
                
                let tt = setTimeout(()=>{
                    clearTimeout(tt);
                    self.init();
                    self.showGift = true;

                    if(self.chouzhong.winId > 0){
                        self.dialogPhone = !self.chouzhong.isScore;
                        self.dialogjifen = self.chouzhong.isScore;
                    }else{
                        // 谢谢参与
                        self.dialogNo = true;

                    }
                    
                }, 4000)
                
                
            },
            move(ball){
                // let self = this;
                var speedx = 20 + Number((Math.random()*3).toFixed(1));
                var speedy = 20 + Number((Math.random()*3).toFixed(1));

                let sport = setInterval(function() {
                    ball.style.left = ball.offsetLeft + speedx + 'px';
                    ball.style.top = ball.offsetTop + speedy + 'px';

                    if (ball.offsetTop >= 160 - 20 || ball.offsetTop <= 0) {
                        speedy *= -1;
                    }
                    if (ball.offsetLeft >= 200 - 20 || ball.offsetLeft <= 0) {
                        speedx *= -1;
                    }
                }, 50)
                let tt = setTimeout(()=>{
                    clearTimeout(tt);
                    clearInterval(sport);
                }, 4000)
                
            },
            async getList(){
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    // self.onShowLoginPop();
                    self.$message({
                        message: '需要先登陆哦！'
                    })
                    return;
                }
                let res = await api({
                    method: 'giftList',
                    token
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                if(code ==200){
                    self.giftList = data;
                    // console.log(data)
                    self.createEl()
                }
            }
        },
        mounted() {
            let self =this;
            self.actId = self.query && self.query.__sa || 1;
            this.getList()
            this.getCanRunNums(); // 剩余抽奖次数
            this.getZhongjiang(); // 小喇叭

            
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import 'style.less';
</style>